/**
 * Firebase client — points at the INTERNAL project only (doc 147 §8.5).
 *
 * Reads `VITE_INTERNAL_FIREBASE_*` — never the customer app's `VITE_FIREBASE_*`.
 * Thin SDK initialization; excluded from unit-test coverage (exercised by the
 * emulator). All logic lives in the sibling modules.
 */
import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, connectAuthEmulator, type Auth } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator, type Firestore } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator, type Functions } from 'firebase/functions';
import { getStorage, connectStorageEmulator, type FirebaseStorage } from 'firebase/storage';

const useEmulators = import.meta.env.VITE_USE_EMULATORS === 'true';

export const firebaseApp: FirebaseApp = initializeApp({
  apiKey: import.meta.env.VITE_INTERNAL_FIREBASE_API_KEY,
  appId: import.meta.env.VITE_INTERNAL_FIREBASE_APP_ID,
  authDomain: import.meta.env.VITE_INTERNAL_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_INTERNAL_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_INTERNAL_FIREBASE_STORAGE_BUCKET,
});

export const auth: Auth = getAuth(firebaseApp);
export const db: Firestore = getFirestore(firebaseApp);
export const functions: Functions = getFunctions(firebaseApp, 'us-central1');
export const storage: FirebaseStorage = getStorage(firebaseApp);

if (useEmulators) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
  connectFunctionsEmulator(functions, '127.0.0.1', 5001);
  connectStorageEmulator(storage, '127.0.0.1', 9199);
}
